import axios, { type AxiosInstance } from 'axios'
import { getAccessToken } from './auth'

const baseURL = import.meta.env.VITE_API_BASE_URL || '/api'

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
})

apiClient.interceptors.request.use(async (config) => {
  // Skip auth in mock/dev when MSAL not configured
  if (!import.meta.env.VITE_ENTRA_CLIENT_ID) {
    return config
  }
  try {
    const token = await getAccessToken()
    config.headers.set('Authorization', `Bearer ${token}`)
  } catch {
    // Let backend reject — interceptor doesn't redirect
  }
  return config
})

export interface ApiOk<T> {
  success: true
  data: T
}
export interface ApiErr {
  success: false
  error: string
}
export type ApiResponse<T> = ApiOk<T> | ApiErr

export async function unwrap<T>(promise: Promise<{ data: ApiResponse<T> }>): Promise<T> {
  const result = await promise
  if (!result.data.success) throw new Error(result.data.error)
  return result.data.data
}
